module.exports = __webpack_public_path__ + "files/739427a049b11975d892f47ccee1c0af.png";